try {
    $(document).ready(function () {
        if (($(window).width() <= 1200) && ($(window).width() > 574)) {
            $('#datetimepicker1').click(function () {
                if ($('.bootstrap-datetimepicker-widget').css('bottom') === '51px') {
                    var heightWidget = $('.bootstrap-datetimepicker-widget').height();
                    $("body,html").animate(
                        {
                            scrollTop: $("#datetimepicker1").offset().top - (heightWidget + 71)
                        },
                        100
                    );
                } else if ($('.bootstrap-datetimepicker-widget').css('top') === '51px') {
                    $("body,html").animate(
                        {
                            scrollTop: $("#datetimepicker1").offset().top - 20
                        },
                        100
                    );
                }
            });
        } else if ($(window).width() <= 574) {
            $('#datetimepicker1').click(function () {
                if ($('.bootstrap-datetimepicker-widget').css('bottom') === '51px') {
                    var heightWidget = $('.bootstrap-datetimepicker-widget').height();
                    $("body,html").animate(
                        {
                            scrollTop: $("#datetimepicker1").offset().top + 91 - (heightWidget * 2)
                        },
                        100 //speed
                    );
                } else if ($('.bootstrap-datetimepicker-widget').css('top') === '51px') {
                    $("body,html").animate(
                        {
                            scrollTop: $("#datetimepicker1").offset().top - 20
                        },
                        100 //speed
                    );
                }
            });
        }
    });
} catch (error) {
    console.error(error);
}

